var map = {
	"./404.svg": "sEM+",
	"./accounting.svg": "s64A",
	"./accountingTitle.svg": "G0eS",
	"./aiayam_chicken1.svg": "lbk+",
	"./aiayam_duck1.svg": "gztM",
	"./bookmark_solid.svg": "TxrP",
	"./bug.svg": "SVqS",
	"./business.svg": "Br7G",
	"./businessTitle.svg": "WlE0",
	"./card-outline.svg": "x5ri",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./community.svg": "eMQv",
	"./communityTitle.svg": "KyAH",
	"./component.svg": "s2cW",
	"./d20_dice.svg": "7py6",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./git_pull_request.svg": "yWUJ",
	"./guide.svg": "z74U",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./moon.svg": "Ux9W",
	"./nested.svg": "798r",
	"./ow_clock1.svg": "276O",
	"./ow_clock2.svg": "wIuY",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./play.svg": "ufmG",
	"./posit1ve-l.svg": "H7pL",
	"./posit1ve-s.svg": "cCg9",
	"./qq.svg": "R2jY",
	"./repeat_solid.svg": "m6cO",
	"./shoppingCard.svg": "dNDk",
	"./slm-1-siluman.svg": "MLzn",
	"./slm-2-gergasi.svg": "nEI/",
	"./slm-3-raksasa.svg": "42cj",
	"./slm-4-naga.svg": "0hVn",
	"./star.svg": "60zo",
	"./stop_circle.svg": "QjFp",
	"./sun.svg": "ZJ0R",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./taskmaster.svg": "V6pt",
	"./taskmasterTitle.svg": "euTW",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./volume2.svg": "WRFd",
	"./volumeX.svg": "af3k",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 11